import React from 'react';
import TablaSolicitudAnuncio from './Tablas/TablaSolicitudAnuncio';
import GraficoSolicitudAnuncio from './Graficos/GraficoSolicitudAnuncio';
import { VStack, Heading, Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import ObrasAnuncioDashboard from './Dashboard/ObrasAnuncioDashboard';
import { AddIcon } from '@chakra-ui/icons';
import SolicitudAnuncio from './Ventanas/SolicitudAnuncio';

const ObrasAnuncio: React.FC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
  
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Anuncio
      </Heading>
      <ObrasAnuncioDashboard></ObrasAnuncioDashboard>
      <TablaSolicitudAnuncio />
   

            <Button
  position="fixed"
  bottom="20px"
  right="23px"
  colorScheme="green"
  borderRadius="full" 
  width="60px" 
  height="60px" 
  boxShadow="lg"
  zIndex={10} 
  onClick={()=>{
    onOpen();
  }}
>

<AddIcon />

</Button>

<Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detalle de SolicitudAnuncio</ModalHeader>
          <ModalBody>
<SolicitudAnuncio modo='new'/>
 </ModalBody>
          {/* <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>Cerrar</Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>

      {/* <GraficoSolicitudAnuncio /> */}
    </VStack>
  );
};

export default ObrasAnuncio;
